require('./impromptu');
let form = require('../form/form');

jQuery(function() {
    var specialRegGiftPromptHtml =
        '<div class="special-action special-action--blue">' +
        '<img class="special-action__bg-img" src="local/assets/img/bg-reg-gift.jpg" alt="1000 РУБЛЕЙ за регистрацию" />' +
        '<div class="special-action__content">' +
        '<div class="special-action__box special-action__box--white">' +
        '<span class="special-action__box-big-text">1000 рублей</span> <span class="special-action__box-normal-text">за регистрацию</span>' +
        '</div>' +
        '<div class="form form--fullwidth">' +
        '<div class="form__field icon-field icon-field--man">' +
        '<div class="icon-field icon-field--man">' +
        '<input type="email" name="quick_reg_email" placeholder="Введите e-mail" class="form__input form__input--shade icon-field__input" />' +
        '</div>' +
        '</div>' +
        '<div class="form__field jqibuttons">' +
        '<button class="btn-def btn-def--pink btn-def--w100" value="quick-reg">Зарегистрироваться</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    var specialRegBenefitsPromptHtml =
        '<div class="special-action special-action--dark-pink">' +
        '<img class="special-action__bg-img" src="local/assets/img/bg-reg-gift-2.jpg" alt="1000 РУБЛЕЙ за регистрацию" />' +
        '<div class="special-action__content">' +
        '<ol class="reg-benefits reg-benefits--compact">' +
        '<li class="reg-benefits__item">Если вы косметолог, Вы можете покупать товары по <b>ОПТОВОЙ ЦЕНЕ!</b></li>' +
        '<li class="reg-benefits__item"><b>1000 РУБЛЕЙ</b> в&nbsp;подарок на первую покупку</li>' +
        '<li class="reg-benefits__item">Зарегистрируйтесь и получите электронную книгу в <b>ПОДАРОК!</b></li>' +
        '</ol>' +
        '<div class="form form--fullwidth">' +
        '<div class="form__field icon-field icon-field--man">' +
        '<div class="icon-field icon-field--man">' +
        '<input type="email" name="quick_reg_email" placeholder="Введите e-mail" class="form__input form__input--shade icon-field__input" />' +
        '</div>' +
        '</div>' +
        '<div class="form__field form__field--nomargin jqibuttons">' +
        '<button class="btn-def btn-def--w100" value="quick-reg">Зарегистрироваться</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    function promoSubmit(e, v, m) {
        e.preventDefault();
        var $params = $.extend({}, form.formValidateDefaults, {
            rules: {
                quick_reg_email: { required: true, email: true }
            },
            messages: {
                quick_reg_email: {
                    required: 'Не указан e-mail',
                    email: 'Указан неверный e-mail'
                }
            },
            submitHandler: function() {
                //form.submit();

                // данные формы:
                // console.log(f);

                //тест. все поля заполнены верно
                $.prompt
                    .getState('state0')
                    .find('.form')
                    .html('<p>Регистрация</p>');
                //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
                // чтобы не казалось, будто он совсем пропал с экрана
                $.prompt.position();
                //$.prompt.close();
            }
        });
        var $form = m.closest('form');
        $form.validate($params);
    }

    $('.js-show-reg-gift-popup').click(function(e) {
        e.preventDefault();

        $.prompt(specialRegGiftPromptHtml, {
            buttons: {},
            persistent: false, //чтобы можно было закрыть при клике по оверлею
            classes: {
                prompt: 'prompt--large',
                form: 'prompt__form-special',
                close: 'jqiclose--cross jqiclose--pink-cross'
            },
            submit: promoSubmit
        });
    });

    $('.js-show-reg-benefits-popup').click(function(e) {
        e.preventDefault();

        $.prompt(specialRegBenefitsPromptHtml, {
            buttons: {},
            persistent: false, //чтобы можно было закрыть при клике по оверлею
            classes: {
                prompt: 'prompt--large',
                form: 'prompt__form-special',
                close: 'jqiclose--cross jqiclose--pink-cross'
            },
            submit: promoSubmit
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-reg-promo.js